import vue from 'vue'

const title = vue.directive('title', {
    inserted: function(el) {
        document.title = el.getAttribute('title')
    }
})

export default title